// extracted by css-extract-rspack-plugin
export default {"checkbox":"checkbox--R_mnNERtPUqpN8pP"};